import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { INPROGRESS, NEEDS_UPDATE } from '../constants';
import moment from 'moment';
import { hasETACrossed } from './helper';
import { DATE_FORMAT } from '../../../constants';
class PortfolioTable extends Component {
    constructor() {
        super();
        this.state = {
            selectedCounterPartyList: []
        }
    }
    handleCheckboxChange = (selectedValue) => {
        let tempSelectedValue = [...this.state.selectedCounterPartyList]
        tempSelectedValue.push(selectedValue)
        this.setState({
            selectedCounterPartyList: tempSelectedValue
        })
    }

    render() {
        return (
            this.props.portfolioData.map(p => {
                let actionCheck,
                    lastUpdateDateCheck,
                    counterpartyNameTitle,
                    deliveryDate,
                    statusLabel,
                    statusText;
                if (p.status[0] !== INPROGRESS) {
                    actionCheck = <Link className="d-inline-block" to={`/report/${p.id}`}>{p.counterpartyName}</Link>
                    deliveryDate = <span><i className="icon-check icon-check-size"></i> &nbsp;{moment(p.deliveryDate).format(DATE_FORMAT)} </span>
                    counterpartyNameTitle = p.counterpartyName;
                    statusLabel = null;
                    statusText = p.status;
                }
                else {
                    actionCheck = p.counterpartyName
                    counterpartyNameTitle = actionCheck
                    deliveryDate = <span className={hasETACrossed(p.deliveryDate) === 1 ? "orange-text" : hasETACrossed(p.deliveryDate) === 2 ? "red_text" : "green_text"} title={moment(p.deliveryDate).format(DATE_FORMAT)}><i className="icon-in-progress"></i> &nbsp;{moment(p.deliveryDate).format(DATE_FORMAT)}</span>
                    statusLabel = <span className="d-sm-none font-size-small">Status : </span>
                    if (p.status[0] === NEEDS_UPDATE) {
                        statusText = "NEEDS UPDATE";
                    }
                    else if (p.status[0] === INPROGRESS) {
                        statusText = "IN PROGRESS";
                    }
                }
                if (p.lastUpdateDate) {
                    lastUpdateDateCheck = moment(p.lastUpdateDate).format(DATE_FORMAT)
                } else {
                    lastUpdateDateCheck = '-'
                }
                return (
                    <Row key={p.id} noGutters className="bg-light p-3 p-sm-0 mb-2 mb-sm-0 custom-table-row company-portfolio">
                        <Col xs="24" sm="5" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0" title={counterpartyNameTitle}>
                            {actionCheck}
                        </Col>
                        <Col xs="24" sm="3" className="custom-table-col px-sm-2 py-sm-3 my-2 my-sm-0 text-sm-center">
                            {p.counterpartyType}
                        </Col>
                        <Col xs="24" sm="4" className="d-sm-none custom-table-col pb-2 py-sm-3 my-3 mb-sm-0 text-truncate">
                            <span className="">Updated on : </span>
                            {lastUpdateDateCheck}
                        </Col>
                        <Col xs="8" sm="4" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-sm-center">
                            <div className={`d-flex pb-2 pb-sm-none ${p.riskLevel}`}>
                                <div>{(p.riskScore) ? Number(p.riskScore).toFixed(1) : '-'}</div>
                                <span className="pl-1"><i className={p.riskScoreTrend}/></span>
                            </div>
                            <div className="d-sm-none py-2 risk-indicator-label">Rubix Risk <br/> Score</div>
                        </Col>
                        <Col xs="8" sm="4" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-sm-center">
                            <div className={`d-flex pb-sm-none ${p.riskLevel}`}>
                                <div>{(p.riskScore) ? Number(p.riskScore).toFixed(1) : '-'}</div>
                                <span className="pl-1"><i className={p.riskScoreTrend}/></span>
                            </div>
                            <div className="d-sm-none py-2 risk-indicator-label">Payment <br/> Score</div>
                        </Col>
                        <Col xs="8" sm="4" className="custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-sm-center">
                            <div className={`d-flex pb-sm-none ${p.riskLevel}`}>
                                <div>{(p.riskScore) ? Number(p.riskScore).toFixed(1) : '-'}</div>
                                <span className="pl-1"><i className={p.riskScoreTrend}/></span>
                            </div>
                            <div className="d-sm-none py-2 risk-indicator-label">CUG <br/> score</div>
                        </Col>
                        <Col xs="24" sm="4" className="d-none d-sm-block custom-table-col px-sm-2 py-sm-3 mb-2 mb-sm-0 text-truncate text-sm-center">
                            {lastUpdateDateCheck}
                        </Col>
                    </Row>
                )

            })
        )
    }
}
export default PortfolioTable;
